// Firmware notification state. Each notification type owns its own field so
// resolving one (e.g. fall recovery) can never clear another (motor / SD fault).
const initialState = {
    battery: null, // { percent, receivedAt }
    isFalling: false,
    motorFaultIds: [],
    sdCardMissing: false,
}

const sameIds = (a, b) => a.length === b.length && a.every((v, i) => v === b[i])

const zingNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ZING_NOTIFICATION': {
            const event = action.payload
            switch (event.type) {
                case 'battery':
                    return {
                        ...state,
                        battery: {
                            percent: event.percent,
                            receivedAt: action.receivedAt ?? Date.now(),
                        },
                    }
                case 'fall':
                    return state.isFalling === event.fallen
                        ? state
                        : { ...state, isFalling: event.fallen }
                case 'motorLink':
                    return sameIds(state.motorFaultIds, event.faultyIds)
                        ? state
                        : { ...state, motorFaultIds: event.faultyIds }
                case 'sdCard':
                    return state.sdCardMissing
                        ? state
                        : { ...state, sdCardMissing: true }
                default:
                    return state
            }
        }
        case 'ZING_NOTIFICATION_RESET':
            return state === initialState ? state : initialState
        default:
            return state
    }
}

export { initialState as zingNotificationInitialState }
export default zingNotificationReducer
